import React, { useEffect, useState } from "react";
import { MapPin, ArrowRight, Search } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHero, Section, PrimaryButton } from "@/components/ui-helpers";
import { api } from "@/lib/api";

export default function ServiceAreas() {
  const [areas, setAreas] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/service-areas").then(({ data }) => setAreas(data)).catch(() => {}); }, []);
  const filtered = areas.filter((a) => a.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <>
      <SEO title="Service Areas" description="Ascendia Detail operates throughout Israel — Jerusalem, Tel Aviv, Ra'anana, Modi'in, Ashdod and more." />
      <PageHero kicker="Service Areas" title="Serving clients throughout Israel" subtitle="We operate across Israel, subject to job size, availability and travel. Here are some of the areas we regularly serve — others are available by request.">
        <PrimaryButton to="/contact">Check availability <ArrowRight className="h-4 w-4" /></PrimaryButton>
      </PageHero>
      <Section>
        <div className="relative max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-c" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search your area…" className="w-full rounded-xl bg-black/40 border border-[color:var(--border-subtle)] pl-10 pr-4 py-3 text-sm text-white placeholder:text-white/35 focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)]" />
        </div>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((a) => (
            <div key={a.id} className="ascendia-card p-5 flex items-center gap-3"><MapPin className="h-5 w-5 text-gold-soft" /> <span className="text-white">{a.name}</span></div>
          ))}
        </div>
        <p className="mt-8 text-sm text-muted-c">Don't see your area? We serve other locations by request — availability everywhere is not guaranteed, so please <a href="/contact" className="text-gold-soft hover:text-gold">get in touch</a> to check.</p>
      </Section>
    </>
  );
}
